export default __webpack_public_path__ + "static/media/dashboard.8ca9c065.svg";